import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './ArtistManagement.css';

const ArtistManagement = () => {
  const artists = [
    'Gitarist',
    'Singer',
    'Anchor',
    'DJ',
    'Dancer',
  ];

  return (
    <div className="artist-management-page">
      <PageBanner
        title="Artist Management"
        image={productionRouteBanners['artist-management']}
        imageAlt={productionRouteBannerAlts['artist-management']}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Artist Management</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Professional artist management for your events
            </p>
          </div>
          
          <div className="artists-grid">
            {artists.map((artist, index) => (
              <div key={index} className="artist-card">
                <h3>{artist}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ArtistManagement;
